<template>
<div>
	{{{line.conteudo}}}
</div>
</template>
<script>
	export default{
		data(){
			return{
			}
		},
        props:['line'],
		ready(){

		}
	}
</script>


// WEBPACK FOOTER //
// conteudotexto.vue?11b50dd6